"use client";
import { useRouter } from "next/navigation";
import { twMerge } from "tailwind-merge";

import { CompactArtistDisplay } from "@/components/compactArtistDisplay/CompactArtistDisplay";
import { Heading2 } from "@/components/text/Heading2";
import { artists } from "@/constants/artists/artists";
import { conversionNamespace } from "@/constants/namespaces";
import { useNamedSelectedArtist } from "@/lib/zustand/useSelectedArtist";
import { ArtistInstumentSaved, UserNoDates } from "@/types/types";

export function TrendingArtists({
  user,
  savedArtistsInstrumentsIds,
  className,
}: {
  user: UserNoDates | null;
  savedArtistsInstrumentsIds: ArtistInstumentSaved["artistInstrumentId"][];
  className?: string;
}) {
  const router = useRouter();

  // because we redirect to /create, we use the conversionNamespace namespace
  const useSelectedArtist = useNamedSelectedArtist((state) =>
    state.getNamedStore(conversionNamespace)
  );
  const setSelectedArtistId = useSelectedArtist(
    (state) => state.setSelectedArtistId
  );

  // Get the first 8 artists
  const trendingArtists = artists.slice(0, 8);

  return (
    <div className={twMerge("mx-auto max-w-6xl px-4 lg:px-8", className)}>
      <Heading2 className="mb-16 text-center">
        Featured royalty-free voices
      </Heading2>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-3 lg:grid-cols-4 xl:gap-x-6">
        {trendingArtists.map((artistItem) => (
          <CompactArtistDisplay
            key={artistItem.id}
            artistInstrumentModelMixedModel={artistItem}
            handleClickArtist={(artistId) => {
              setSelectedArtistId(artistId);
              router.push("/create");
            }}
            user={user}
            elementType="li"
            savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
          />
        ))}
      </ul>
    </div>
  );
}
